var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#E5E7DF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27013_66729",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 21
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8.42578,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27013_66729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3337 25.0911C10.8753 25.0911 10.483 24.928 10.1566 24.6016C9.83019 24.2752 9.66699 23.8828 9.66699 23.4245V13.4245C9.66699 12.9661 9.83019 12.5738 10.1566 12.2474C10.483 11.921 10.8753 11.7578 11.3337 11.7578H24.667C25.1253 11.7578 25.5177 11.921 25.8441 12.2474C26.1705 12.5738 26.3337 12.9661 26.3337 13.4245V23.4245C26.3337 23.8828 26.1705 24.2752 25.8441 24.6016C25.5177 24.928 25.1253 25.0911 24.667 25.0911H11.3337ZM24.667 15.0911L18.4378 18.987C18.3684 19.0286 18.2955 19.0599 18.2191 19.0807C18.1427 19.1016 18.0698 19.112 18.0003 19.112C17.9309 19.112 17.858 19.1016 17.7816 19.0807C17.7052 19.0599 17.6323 19.0286 17.5628 18.987L11.3337 15.0911V23.4245H24.667V15.0911ZM18.0003 17.5911L24.667 13.4245H11.3337L18.0003 17.5911ZM11.3337 15.2995V14.0703V14.0911V14.0807V15.2995Z",
    fill: "#8CAEB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobEmail);
export default __webpack_public_path__ + "static/media/job-email.9f3755dcb59f6c434f1ce1ce1c51f264.svg";
export { ForwardRef as ReactComponent };